module.exports = __webpack_public_path__ + "static/Adobe_Flash_Player_SVG-bd99a804890b7e8acefcd9e38af3cc7d.svg";